import { CustomerInAppNotificationResponseDto } from 'src/api';
import { InAppNotificationPriority } from '../enums/in-app-notification-priority.enum';

// il campo generato `priority` ha un tipo rotto (sempre null), quindi lo leggiamo come numero grezzo
export function getInAppNotificationPriority(notification: CustomerInAppNotificationResponseDto): InAppNotificationPriority {
  return notification.priority as unknown as InAppNotificationPriority;
}

export function getInAppNotificationPriorityKey(
  priority: InAppNotificationPriority
): 'information' | 'important' | 'critical' | 'maintenance' {
  switch (priority) {
    case InAppNotificationPriority.Important:
      return 'important';
    case InAppNotificationPriority.Critical:
      return 'critical';
    case InAppNotificationPriority.Maintenance:
      return 'maintenance';
    case InAppNotificationPriority.Information:
    default:
      return 'information';
  }
}

export function isInAppNotificationActive(
  notification: CustomerInAppNotificationResponseDto,
  now: Date = new Date()
): boolean {
  const startDate = notification.startDate ? new Date(notification.startDate) : null;
  const endDate = notification.endDate ? new Date(notification.endDate) : null;

  return (!startDate || startDate <= now) && (!endDate || now <= endDate);
}

export function sortInAppNotificationsByPriorityDesc(
  notifications: CustomerInAppNotificationResponseDto[]
): CustomerInAppNotificationResponseDto[] {
  return [...notifications].sort((a, b) => getInAppNotificationPriority(b) - getInAppNotificationPriority(a));
}

export function truncateText(text: string | null | undefined, maxLength = 90): string {
  if (!text) return '';
  return text.length > maxLength ? `${text.slice(0, maxLength)}...` : text;
}
